import {NgModule} from '@angular/core';

import {NavbarModule} from 'app/layout/components/navbar/navbar.module';

import {ToolbarModule} from 'app/layout/components/toolbar/toolbar.module';

import {HorizontalLayout1Component} from './layout-1.component';
import {AjudaPanelModule} from '../../components/ajuda-panel/ajuda-panel.module';
import {ChatPanelModule} from "../../components/chat-panel/chat-panel.module";
import {MatSidenavModule} from "@angular/material/sidenav";


@NgModule({
    imports: [
        MatSidenavModule,
        NavbarModule,
        ChatPanelModule,
        AjudaPanelModule,
        ToolbarModule,
        HorizontalLayout1Component
    ],
    exports: [
        HorizontalLayout1Component
    ]
})
export class HorizontalLayout1Module {
}
